import React from 'react';
import { Block } from '@mui/icons-material';
import WeirdPeople1 from "../img/weirdpeople/Weirdpeople1.png";
import WeirdPeople2 from "../img/weirdpeople/Weirdpeople2.png";
import WeirdPeople3 from "../img/weirdpeople/Weirdpeople3.png";
import WeirdPeople4 from "../img/weirdpeople/Weirdpeople4.png";

const WeirdPeople = ({ onImageClick }) => {
  return (
    <>
      <div className="help-center__examples help-center__examples--first">
        <div className="help-center__examples-header">
          <Block />
          <h3 className="help-center__examples-title">Weird people issues to avoid</h3>
        </div>
        
        <div className="help-center__example-card">
          {/* First row - 2 images */}
          <div className="help-center__example-images help-center__example-images--grid-2">
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '350px', height: '350px'}}>
                <img src={WeirdPeople1} alt="Weird people example 1" onClick={() => onImageClick && onImageClick(WeirdPeople1)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                A weird person behind
              </div>
            </div>
            
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '350px', height: '350px'}}>
                <img src={WeirdPeople2} alt="Weird people example 2" onClick={() => onImageClick && onImageClick(WeirdPeople2)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                A crowd of people behind
              </div>
            </div>
          </div>
          
          {/* Second row - 2 images */}
          <div className="help-center__example-images help-center__example-images--grid-2" style={{marginTop: '30px'}}>
            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '350px', height: '350px'}}>
                <img src={WeirdPeople3} alt="Weird people example 3" onClick={() => onImageClick && onImageClick(WeirdPeople3)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                A weird person behind
              </div>
            </div>

            <div className="help-center__image-placeholder help-center__image-placeholder--dont">
              <div className="help-center__image-label">Don't</div>
              <div className="help-center__image-box" style={{width: '350px', height: '350px'}}>
                <img src={WeirdPeople4} alt="Weird people example 4" onClick={() => onImageClick && onImageClick(WeirdPeople4)} style={{cursor: 'pointer'}} />
              </div>
              <div className="help-center__image-caption">
                A weird person behind
              </div>
            </div>
          </div>
          
         
        </div>
      </div>
    </>
  );
};

export default WeirdPeople;